module.exports = __webpack_public_path__ + "static/img/registration2.e5f62190.png";